import { motion } from "framer-motion";
import styled from "styled-components";

export const OrbitModeContainer = styled.div`
	position: absolute;
	width: calc(100% - 10%);
	height: auto;
	z-index: 909;
	right: 5%;
	top: var(--orbit-controls-top, calc(104px + 18px));
	pointer-events: none;
	color: white;

	.wrapper {
		display: flex;
		justify-content: flex-end;
		align-items: flex-start;
		pointer-events: none;
		gap: 15px;
		transition: all 0.5s ease-in-out;
	}

	.exterior {
		width: 148px;
		height: 40px;
		border-radius: 65px;
		margin-right: 15px;
		border: none;
		cursor: pointer;
		pointer-events: auto;
		transition: all 0.3s ease-in-out;
	}

	.interior {
		width: 148px;
		height: 40px;
		border-radius: 65px;
		margin-right: 15px;
		border: none;
		cursor: pointer;
		pointer-events: auto;
		transition: all 0.3s ease-in-out;
	}

	.powertrain {
		width: 148px;
		height: 40px;
		border-radius: 65px;
		margin-right: 8px;
		border: none;
		cursor: pointer;
		pointer-events: auto;
		transition: all 0.3s ease-in-out;
	}

	.interior:hover {
		scale: 1.1;
	}

	.exterior:hover {
		scale: 1.1;
	}

	.powertrain:hover {
		scale: 1.1;
	}

	@media (max-width: 1240px) {
		.wrapper {
			flex-direction: column;
			align-items: flex-end;
			gap: 8px;
		}

		.exterior,
		.interior,
		.powertrain {
			width: 120px;
			height: 36px;
			font-size: 12px;
			margin-right: 0;
		}
	}

	@media (max-width: 640px) {
		.exterior,
		.interior,
		.powertrain {
			width: 92px;
			height: 32px;
			font-size: 12px;
			margin-right: 0;
		}
	}
`;
export const BackBtnContainer = styled(motion.div)`
	position: absolute;
	z-index: 909;

	cursor: pointer;
	left: 5%;
	height: ${(props) => props.height || "32px"};
	width: ${(props) => props.width || "32px"};
	top: ${(props) =>
		props.top || "var(--orbit-controls-top, calc(104px + 18px))"};
	img:hover {
		scale: 1.1;
	}
	img {
		transition: transform 0.3s ease-in-out;
		width: ${(props) => props.width};
		height: ${(props) => props.height};
	}
`;
export const DayNightToggleContainer = styled(motion.div)`
	position: absolute;
	z-index: 909;
	cursor: pointer;
	left: 50%;
	top: ${(props) =>
		props.top || "var(--orbit-controls-top, calc(104px + 18px))"};
	transform: translateX(-50%);
	transition: opacity 0.5s ease-in-out;

	img {
		height: ${(props) => props.height || "auto"};
		/* transform: translate(-50%, -50%); */
	}
`;
export const MobileOrbitModeContainer = styled.div`
	.exterior {
		width: 97px;
		height: 32.29px;
		border-radius: 65px;
		border: none;
		cursor: pointer;
		transition: all 0.3s ease-in-out;
	}

	.interior {
		width: 97px;
		height: 32.29px;
		border-radius: 65px;
		border: none;
		cursor: pointer;
		transition: all 0.3s ease-in-out;
	}

	.powertrain {
		width: 97px;
		height: 32.29px;
		border-radius: 65px;
		border: none;
		cursor: pointer;
		transition: all 0.3s ease-in-out;
	}
`;
